import { HTTP } from './helpers/http.js'
import qs from 'qs'

export default {
  create(organizationId, payload) {
    const url = `/api/v1/organizations/${organizationId}/recognitions`
    return HTTP.post(url, payload)
  },

  getAll(organizationId, options = {}) {
    const params = {
      params: options,
      paramsSerializer(params) {
        return qs.stringify(params, { arrayFormat: 'brackets' })
      },
    }

    const url = `/api/v1/organizations/${organizationId}/recognitions`
    return HTTP.get(url, params)
  },

  getById(organizationId, recognitionId) {
    const url = `/api/v1/organizations/${organizationId}/recognitions/${recognitionId}`
    return HTTP.get(url)
  },

  update(organizationId, recognitionId, recognition) {
    const url = `/api/v1/organizations/${organizationId}/recognitions/${recognitionId}`

    return HTTP.patch(url, recognition)
  },

  delete(organizationId, recognitionId) {
    const url = `/api/v1/organizations/${organizationId}/recognitions/${recognitionId}`
    return HTTP.delete(url)
  },

  getAccountSummary(organizationId, accountId, options) {
    const url = `api/v1/organizations/${organizationId}/recognitions/account-summary/${accountId}`

    const params = {
      params: options,
      paramsSerializer(params) {
        return qs.stringify(params, { arrayFormat: 'brackets' })
      },
    }

    return HTTP.get(url, params)
  },

  getTopAccounts(organizationId, filters) {
    const url = `api/v1/organizations/${organizationId}/recognitions/top-accounts`

    const params = {
      params: filters,
      paramsSerializer(params) {
        return qs.stringify(params, { arrayFormat: 'brackets' })
      },
    }

    return HTTP.get(url, params)
  },
  like(organizationId, recognitionId) {
    const url = `/api/v1/organizations/${organizationId}/recognition/${recognitionId}/like`

    return HTTP.post(url)
  },
  unlike(organizationId, recognitionId) {
    const url = `/api/v1/organizations/${organizationId}/recognition/${recognitionId}/unlike`

    return HTTP.post(url)
  },
}
